import { useNewRowAlerts } from './hooks/useNewRowAlerts.js';

// Mirrors the market-hours gate the /result_analysis page itself uses for its live refresh.
const isWithinMarketHoursAndDays = () => {
  const now = new Date();
  const start = new Date();
  const end = new Date();
  start.setHours(9, 15, 0, 0);
  end.setHours(15, 30, 0, 0);

  const dayOfWeek = now.getDay();
  const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
  return isWeekday && now >= start && now <= end;
};

// Each stock has a single result row per day, so the stock symbol alone is the row key.
const rowKey = (row) => row.Stock;

// Mounted globally in App.js (inside RowAlertProvider, outside the routed pages) so a new
// stock result on /result_analysis pops up no matter which page the user is currently viewing.
const ResultAnalysisAlert = () => {
  useNewRowAlerts({
    endpoint: 'https://live1.finstrats.com/result_data',
    rowKey,
    title: 'New Result Update',
    renderDetail: (row) => `${row.Stock}${row.Result_Score ? ` - ${row.Result_Score}` : ''}`,
    linkTo: '/result_analysis',
    isRowValid: (row) => Boolean(row.Stock),
    isPollingWindowOpen: isWithinMarketHoursAndDays,
    pollIntervalMs: 30 * 1000,
  });

  return null;
};

export default ResultAnalysisAlert;
